module.exports = __webpack_public_path__ + "img/role_button2.b3e05683.png";